import React, { useState } from "react";
import LogoutButton from "../../components/LogoutButton";
import "../../index.css";
import CollectionsSummary from "../../components/CollectionSummary";
import MemoryExplorer from "../../components/MemoryExplorer";
import AddCollection from "../../components/AddCollection";
import VectorAdder from "../../components/VectorAdder/VectorAdder";

export default function Home() {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const triggerRefresh = () => setRefreshFlag(prev => prev + 1);

    return (
        <>
            {/* Le bouton de déconnexion vit ici, dans la barre : en position
                fixe il recouvrait le contenu des colonnes de droite. */}
            <header className="app-header">
                <div className="app-header__brand">
                    <h1>Butterfly Vectors</h1>
                    <span className="app-header__tag">Mémoire de traduction</span>
                </div>
                <LogoutButton />
            </header>

            <div id="app-container">
                <div className="layout">
                    <div className="stack">
                        <VectorAdder />
                        <CollectionsSummary refreshFlag={refreshFlag} onAdd={triggerRefresh}>
                            <AddCollection onAdd={triggerRefresh} />
                        </CollectionsSummary>
                    </div>

                    <div className="stack">
                        <MemoryExplorer />
                    </div>
                </div>
            </div>
        </>
    );
}
